// PARAQTA — қолданба state-і (currentUser, isGuest, ws, wsRetry).
//
// Module-ден экспортталатын `let` айнымалыларын СЫРТТАН тікелей
// өзгертуге БОЛМАЙДЫ (ES module семантикасы — read-only binding).
// Сол үшін setter функциялар жасалды.
//
// window.currentUser / window.isGuest — inline <script> кодынан
// еркін оқу/жазу үшін (bare identifier → window fallthrough).

export let currentUser = null;
export let isGuest = false;
export let ws = null;
export let wsRetry = 0;

export function setCurrentUser(user) {
  currentUser = user;
  window.currentUser = user;
}

export function setIsGuest(val) {
  isGuest = val;
  window.isGuest = val;
}

export function setWs(socket) {
  ws = socket;
  window.ws = socket;
}

export function getWs() {
  return ws;
}

export function incrWsRetry() {
  wsRetry += 1;
  window.wsRetry = wsRetry;
  return wsRetry;
}

export function resetWsRetry() {
  wsRetry = 0;
  window.wsRetry = 0;
}
